export enum ProfileFileType {
  AVATAR = "avatar",
  BACKGROUND = "background_image",
}

export interface IFileUploadingType {
  loading: boolean;
  type?: ProfileFileType;
}
